import * as React from "react";
import { useRoutes } from "react-router";
import Login from "../app/auth/Login";
import Perkataan from "../app/layout/perkataan/Perkataan";
import AddPerkataan from "../app/layout/perkataan/addperkataan/AddPerkataan";
import EditPerkataan from "../app/layout/perkataan/editperkataan/EditPerkataan";
import AddUser from "../app/layout/user/adduser/AddUser";
import EditUser from "../app/layout/user/edituser/EditUser";
import ChangePassword from "../app/layout/changepassword/ChangePassword";
import User from "../app/layout/user/User";
import Layout from "../app/layout/Layout";
import PageNotFound from "../components/PageNotFound";
import Role from "../app/layout/role/Role";
import AddEditRole from "../app/layout/role/components/AddEditRole";
import ProtectedRoute from "../components/ProtectedRoute";

export default function RootNavigation() {
  const routes = useRoutes([
    { path: "/login", element: <Login /> },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        { path: "/", element: <Perkataan /> },
        { path: "add-perkataan", element: <AddPerkataan /> },
        { path: "edit-perkataan/:id", element: <EditPerkataan /> },
        { path: "user-list", element: <User /> },
        { path: "user-list/add-user", element: <AddUser /> },
        { path: "user-list/edit-user/:id", element: <EditUser /> },
        { path: "role-list", element: <Role /> },
        { path: "role-list/edit-role/:id", element: <AddEditRole /> },
        { path: "role-list/add-role", element: <AddEditRole /> },
        { path: "change-password", element: <ChangePassword /> },
      ],
    },
    { path: "*", element: <PageNotFound /> },
  ]);

  return routes;
}
